<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                {{ repo.slug }}
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Helm Repository '{{repo.slug}}'</h2>
            <span class="sm-text">This page contains list of helm charts for '{{ repo.slug }}' repository</span>
        </template>


        <div class="card-style" v-if="helmCharts.length > 0">
            <p class="title">To start using this repository run following helm command:</p>
            <div class="command-line">
                <p>helm repo add {{ route('repository.view', {team: repo.slug}) }} --username {{ username }} --password [password_or_token]</p>
            </div>
            <p style="color: #a0a0a0; font-size: 14px; margin-top: 10px">For the password you may use your account password, or an API key. Alternatively you can use deploy token instead of username and password.</p>
        </div>

        <div class="col-lg pt-3 pb-4" v-if="helmCharts.length > 0">
            <div class="card-style">
                <table class="table-style helm-chart-table">
                    <thead>
                    <tr>
                        <th>Helm Chart Name</th>
                        <th>Latest Version</th>
                        <th>Latest release date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="chart in helmCharts">
                        <td><inertia-link :href="route('helm-chart.view', {team: repo, helm_chart: chart })">{{ chart.chart_name }}</inertia-link></td>
                        <td>{{latestPackages[chart.id].version}}</td>
                        <td>{{dateFormating(latestPackages[chart.id].releaseDate)}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <push-instructions :slug="repo.slug" :username="username" />
        </div>

        <template #rightSidebar>
            <repository-sidebar :slug="repo.slug" :show-repo-add="helmCharts.length > 0" :username="username" />
        </template>
    </main-layout>
</template>

<script>

    import MainLayout from "@/Layouts/MainLayout";
    import Pagination from "@/Components/Pagination";
    import PushInstructions from "@/Pages/Repository/PushInstructions";
    import RepositorySidebar from "@/Pages/Repository/RepositorySidebar";
    export default {
        name: "ListHelmCharts",
        components: {
            RepositorySidebar,
            PushInstructions,
            MainLayout,
            Pagination
        },
        props: ['repo', 'helmCharts', 'latestPackages', 'username'],
        methods: {
            dateFormating(date) {
                let newDate = new Intl.DateTimeFormat('en-GB', {dateStyle: 'medium'}).format(new Date(date));
                return newDate;
            },
        }
    }
</script>

<style scoped>

</style>
